import LogoContainer from './LogoContainer'

export default LogoContainer
